import { render } from "./Pagination.vue?vue&type=template&id=ffd97b4e"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Pagination.vue?vue&type=style&index=0&id=ffd97b4e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__